/**
 *
 * @param {String} json
 */

export default function parseJsonArray (json) {
	if (json) {
		try {
			const jsonParse = JSON.parse(json)

			if (jsonParse && Array.isArray(jsonParse)) {
				return jsonParse
			} else {
				return []
			}
		} catch (e) {
			return []
		}
	} else {
		return []
	}
}




// WEBPACK FOOTER //
// ./src/assets/js/functions/parseJsonArray.js